import React from 'react';

export const Send = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? '20'}
    height={height ?? '20'}
    viewBox="0 0 20 20"
    fill="none"
  >
    <mask
      id="mask0_1960_30103"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width={width ?? '20'}
      height={height ?? '20'}
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1960_30103)">
      <path
        d="M2.5 17.6248V2.375L18.3333 9.99992L2.5 17.6248ZM4.16667 14.7655L14.0417 9.99992L4.16667 5.23434V8.57025L9.16667 9.99992L4.16667 11.4296V14.7655Z"
        fill="white"
      />
    </g>
  </svg>
);
